import React, { ReactNode } from 'react';
import { Breadcrumb } from '../../../shared/web/layout/Breadcrumbs';
import { useSetupAreaVersionContextRequired } from './SetupAreaVersionContext';
import { SetupAreaVersionBreadcrumbs } from './SetupAreaBreadcrumbs';

export default function MarketsBreadcrumbs(
  props: {
    children?: ReactNode,
    text: string,
  }
) {
  const {
    setupArea,
    setupAreaVersion
  } = useSetupAreaVersionContextRequired();

  return (
    <SetupAreaVersionBreadcrumbs setupArea={setupArea} version={setupAreaVersion.version}>

      <Breadcrumb text={props.text}>
        {props.children}
      </Breadcrumb>
    </SetupAreaVersionBreadcrumbs>
  );
}
